import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface IUIState {
  viewport: IViewportState;
  theme: { mode: "light" | "dark" };
  navigation: { focused: boolean };
}

interface IViewportState {
  clientWidth: number;
  offsetWidth: number;
  scrollWidth: number;
  clientLeft: number;
  scrollLeft: number;
}

const initialState: IUIState = {
  viewport: {
    clientWidth: 0,
    offsetWidth: 0,
    scrollWidth: 0,
    clientLeft: 0,
    scrollLeft: 0
  },
  theme: { mode: "light" },
  navigation: { focused: false }
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    updateTarget(state, { payload }: PayloadAction<HTMLDivElement>) {
      state.viewport.clientWidth = payload.clientWidth;
      state.viewport.offsetWidth = payload.offsetWidth;
      state.viewport.scrollWidth = payload.scrollWidth;
      state.viewport.clientLeft = payload.clientLeft;
      state.viewport.scrollLeft = payload.scrollLeft;
    }
  }
});

export const { updateTarget } = uiSlice.actions;
export default uiSlice.reducer;
export const selectViewport = (state: { ui: IUIState }) => state.ui.viewport;
